module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"pageTitle":"Публичная оферта"}}')
  delete Component.options._Ctor
}
